import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

// Styles the assistant's care-recommendation markdown to match the app's
// hand-rolled aesthetic (ink tokens, compact spacing). The markdown is
// model-generated and trusted — react-markdown does not render raw HTML.
const components: Components = {
  h1: ({ children }) => (
    <h2 className="font-display font-bold text-xl text-ink m-0 mt-3.5 mb-1.5 tracking-tight first:mt-0">{children}</h2>
  ),
  h2: ({ children }) => (
    <h3 className="font-display font-bold text-lg text-ink m-0 mt-3.5 mb-1.5 tracking-tight first:mt-0">{children}</h3>
  ),
  h3: ({ children }) => (
    <h4 className="font-display font-semibold text-base text-ink m-0 mt-3 mb-1 tracking-tight first:mt-0">{children}</h4>
  ),
  p: ({ children }) => (
    <p className="text-[13px] text-ink m-0 my-1.5 leading-normal">{children}</p>
  ),
  ul: ({ children }) => (
    <ul className="list-disc pl-4.5 m-0 my-1.5 flex flex-col gap-1">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal pl-4.5 m-0 my-1.5 flex flex-col gap-1">{children}</ol>
  ),
  li: ({ children }) => (
    <li className="text-[13px] text-ink leading-[1.4] marker:text-ink-3">{children}</li>
  ),
  strong: ({ children }) => <strong className="font-medium text-ink">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  a: ({ children, href }) => (
    <a href={href} className="text-moss underline" target="_blank" rel="noreferrer">{children}</a>
  ),
};

export function Markdown({ children }: Readonly<{ children: string }>) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {children}
    </ReactMarkdown>
  );
}
